export default class LmeDetailsWarehouseController {
    constructor($state, $filter, UIService, AuthenticationService, LmeService, LmeAmostra, LmeCliente, PRIClientes, PRIAJLClientes, LmeMarca, LmeEstadoAmostra, LmeAmostraAlteracaoEstado, LmeAmostraAlteracaoLocal, LmeLocal, LmeAmostraDocumentos, $http, FileUploader) {
        this.state = $state;
        this.filter = $filter;
        this.UI = UIService;
        this.Auth = AuthenticationService;
        this.LmeService = LmeService;
        this.LmeAmostraAlteracaoEstado = LmeAmostraAlteracaoEstado;
        this.LmeAmostraAlteracaoLocal = LmeAmostraAlteracaoLocal;
        this.LmeEstadoAmostra = LmeEstadoAmostra;
        this.LmeAmostra = LmeAmostra;
        this.LmeCliente = LmeCliente;
        this.PRIClientes = PRIClientes;
        this.PRIAJLClientes = PRIAJLClientes;
        this.LmeMarca = LmeMarca;
        this.LmeLocal = LmeLocal;
        this.LmeAmostraDocumentos = LmeAmostraDocumentos;
        this.$http = $http;
        this.FileUploader = FileUploader;
        this.loaded = false;
        this.locais = null;
        this.docs = [];
        this.hasLatestImage = false;
        this.latestImageName = null;
        this.locaisInside = null;
        this.locaisOutside = null;
        this.estadosSaida = null;
        this.estadosEntrada = null;
        this.history = {
            place: 3,
            state: 3,
            proc: 3
        };
        this.id = $state.params.id;
        this.estadosSaida = null;
        this.estadosEntrada = null;
        if (angular.isUndefined($state.params.id) || isNaN($state.params.id) || $state.params.id.toString().length === 0) {
            this.state.go('app.lab.warehouse.list');
        }
        else {
            this.loadData();
            // Used when selecting Local "Fora das instalações" and Estado not outside
            this.getLocais();
        }
    }
    getLocais = () => {
        this.LmeLocal.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((res) => {
            this.locais = res;
            this.locaisInside = this.locais.filter(x => x.inside);
            this.locaisOutside = this.locais.filter(x => !x.inside);
        }).catch((error) => {
            console.log(error);
        });
    };
    getEstados = () => {
        this.LmeEstadoAmostra.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise.then(estados => {
            this.estados = estados;
            this.estadosSaida = this.estados.filter(x => !x.inside);
            this.estadosEntrada = this.estados.filter(x => x.inside);
        }).catch(err => {
            console.log(err);
        });
    };
    formatZipCode = () => {
        if (this.amostra.cliente.cp4 === null) {
            this.amostra.cliente.formatedZipCode = "N/D";
        }
        else if (this.amostra.cliente.cp3 === null) {
            this.$http({
                url: '/api/public/getLocalidade',
                method: 'POST',
                async: true,
                data: {
                    cp4: "" + this.amostra.cliente.cp4,
                    cp3: null
                }
            }).then(response => {
                this.amostra.cliente.localidade = response.data.result;
                this.amostra.cliente.formatedZipCode = this.amostra.cliente.cp4 + " " + this.amostra.cliente.localidade;
            });
        }
        else if (this.amostra.cliente.cp3 !== null) {
            this.$http({
                url: '/api/public/getLocalidade',
                method: 'POST',
                async: true,
                data: {
                    cp4: "" + this.amostra.cliente.cp4,
                    cp3: ("000" + this.amostra.cliente.cp3).slice(-3)
                }
            }).then(response => {
                this.amostra.cliente.cp3 = ("000" + this.amostra.cliente.cp3).slice(-3);
                this.amostra.cliente.localidade = response.data.result;
                this.amostra.cliente.formatedZipCode = this.amostra.cliente.cp4 + "-" + this.amostra.cliente.cp3 + " " + this.amostra.cliente.localidade;
            });
        }
    };
    loadData = () => {
        this.loaded = false;
        // Get locais for modal
        this.getLocais();
        // Get estados for modal
        this.getEstados();
        this.LmeMarca.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise.then(marcas => {
            this.marcas = marcas;
            this.LmeAmostra.findOne({
                filter: {
                    where: {
                        id: this.id,
                        active: true
                    },
                    include: [{
                            relation: 'cliente',
                            scope: {
                                where: {
                                    active: 1
                                }
                            }
                        }, {
                            relation: 'estado',
                            scope: {
                                where: {
                                    active: 1
                                }
                            }
                        }, {
                            relation: 'marca',
                            scope: {
                                where: {
                                    active: 1
                                }
                            }
                        }, {
                            relation: 'local',
                            scope: {
                                where: {
                                    active: 1
                                }
                            }
                        }, {
                            relation: 'historico',
                            scope: {
                                where: {
                                    active: 1
                                },
                                include: [{
                                        relation: 'inicial',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }, {
                                        relation: 'final',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }, {
                                        relation: 'funcionario',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }],
                                order: 'id desc'
                            }
                        },
                        {
                            relation: 'movimentacoes',
                            scope: {
                                where: {
                                    active: 1
                                },
                                include: [{
                                        relation: 'inicial',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }, {
                                        relation: 'final',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }, {
                                        relation: 'funcionario',
                                        scope: {
                                            where: {
                                                active: 1
                                            }
                                        }
                                    }],
                                order: 'id desc'
                            }
                        },
                        {
                            relation: 'ProcessoAmostra',
                            scope: {
                                where: {
                                    active: 1
                                },
                                order: 'processoId DESC',
                                include: {
                                    relation: 'Processo',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        include: [{
                                                relation: 'Tipo',
                                                scope: {
                                                    where: {
                                                        active: 1
                                                    }
                                                }
                                            }, {
                                                relation: 'Estado',
                                                scope: {
                                                    where: {
                                                        active: 1
                                                    }
                                                }
                                            }, {
                                                relation: 'Ordemintervencao',
                                                scope: {
                                                    where: {
                                                        active: 1
                                                    }
                                                }
                                            }, {
                                                relation: 'Laboratorio',
                                                scope: {
                                                    where: {
                                                        active: 1
                                                    },
                                                    include: {
                                                        relation: 'Tipo',
                                                        where: {
                                                            active: 1
                                                        }
                                                    }
                                                }
                                            }, {
                                                relation: 'Historico',
                                                scope: {
                                                    where: { active: true },
                                                    order: 'dataAlteracao desc, id desc',
                                                    include: ['inicial', 'final', 'funcionario', 'atribuidoa', 'suspensao']
                                                }
                                            }, {
                                                relation: 'Tarefas',
                                                scope: {
                                                    where: {
                                                        active: true
                                                    },
                                                    order: 'percentagemFinal desc',
                                                    include: {
                                                        relation: 'funcionario',
                                                        scope: {
                                                            where: {
                                                                active: true
                                                            }
                                                        }
                                                    }
                                                }
                                            }, {
                                                relation: 'Subarea',
                                                scope: {
                                                    where: {
                                                        active: 1
                                                    }
                                                }
                                            }]
                                    }
                                }
                            }
                        }, {
                            relation: 'Documentacao',
                            scope: {
                                where: {
                                    and: [{ active: true }, { documentoId: { neq: 5 } }] // Do not load Etiquetas de Amostra (they are auto-generated)
                                },
                                order: 'id desc',
                                include: 'TipoDocumento'
                            }
                        }]
                }
            }).$promise.then((res) => {
                this.docs = [];
                this.hasLatestImage = false; // To check if amostra has at least an image or not
                this.latestImageName = null;
                res.Documentacao.forEach(doc => {
                    if (!this.hasLatestImage && doc.documentoId === 3) { // If we have imagem, use it immediately
                        this.latestImageName = doc.nome;
                        this.hasLatestImage = true;
                    }
                    this.$http.get('/api/Upload/lme/files/' + doc.nome).then((result) => {
                        if (result.data != null && !result.data.hasOwnProperty('error')) {
                            this.docs.push({
                                info: doc,
                                documentoId: doc.TipoDocumento.id,
                                nome: result.data.name,
                                TipoDocumento: doc.TipoDocumento,
                                atime: result.data.atime,
                                mtime: result.data.mtime,
                                fileSize: result.data.size
                            });
                        }
                    }, (err) => {
                        console.log(err);
                    });
                });
                this.amostra = res;
                // this.formatZipCode();
                this.loaded = true;
            }).catch((error) => {
                console.log(error);
                this.state.go('app.lab.warehouse.list');
                this.UI.addToast('Erro a carregar dados da amostra');
            });
        }).catch((error) => {
            console.log(error);
            this.state.go('app.lab.warehouse.list');
            this.UI.addToast('Erro a carregar dados de marcas');
        });
    };
    viewProcess = r => {
        this.state.go('app.lab.processes.details', {
            id: r.numeroProcesso
        });
    };
    editLocal = () => {
        let amostra = angular.copy(this.amostra);
        let locais = _.filter(this.locais, l => l.id !== this.amostra.local.id);
        let estadosSaida = angular.copy(this.estadosSaida);
        let estadosEntrada = angular.copy(this.estadosEntrada);
        let options = {
            size: 'lg',
            template: require('./../directory/movement.dialog.html'),
            controller: ['$dialog', '$scope', function ($dialog, $scope) {
                    $scope.amostra = amostra;
                    $scope.locais = locais;
                    $scope.estadosSaida = estadosSaida;
                    $scope.estadosEntrada = estadosEntrada;
                    $scope.local = {
                        novoLocal: { selected: null },
                        estadoSaida: { selected: null },
                        estadoEntrada: { selected: null }
                    };
                    $scope.isInside = (estado) => {
                        // Returns true if amostra is located inside, false otherwise
                        return estado && estado.inside;
                    };
                    $scope.ok = () => {
                        $dialog.close($scope.local);
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialog = this.UI.showDialog(options);
        dialog.then(res => {
            if (res) {
                this.loaded = false;
                let oldLocal = angular.copy(this.amostra.local);
                this.LmeAmostraAlteracaoLocal.create({
                    id: 0,
                    amostraId: this.amostra.id,
                    inicialId: oldLocal.id,
                    finalId: res.novoLocal.selected.id,
                    observacoes: res.observacoes,
                    dataAlteracao: new Date(),
                    funcionarioId: this.Auth.getId(),
                    active: true
                }).$promise.then(() => {
                    this.amostra.local.id = res.novoLocal.selected.id;
                    let finalState;
                    // If we were on the outside, going inside, change state
                    if (!oldLocal.inside) { // Fora das instalações
                        finalState = res.estadoEntrada.selected.id;
                        this.saveStateAndAmostraAndReload(finalState, res.observacoes);
                    }
                    else { // If we were on the inside, but going to the outside, change state
                        if (!res.novoLocal.selected.inside) { // Fora das instalações - Moving from inside to outside
                            finalState = res.estadoSaida.selected.id;
                            this.saveStateAndAmostraAndReload(finalState, res.observacoes);
                        }
                        else {
                            this.saveAmostraAndReload();
                        }
                    }
                }).catch(err => {
                    console.log(err);
                    this.UI.addToast('Erro na alteração do local');
                });
            }
        });
    };
    saveStateAndAmostraAndReload = (s, obs) => {
        this.LmeAmostraAlteracaoEstado.create({
            id: 0,
            inicialId: this.amostra.estadoId,
            finalId: s,
            dataAlteracao: new Date(),
            amostraId: this.amostra.id,
            funcionarioId: this.Auth.getId(),
            observacoes: obs,
            active: true
        }).$promise.then((res) => {
            this.amostra.estado.id = s;
            this.saveAmostraAndReload();
        }).catch((error) => {
            console.log(error);
            this.UI.addToast('Erro na alteração de estado/local');
        });
    };
    saveAmostraAndReload = () => {
        this.amostra.$save().then(() => {
            this.loadData();
            this.UI.addToast('Local atualizado com sucesso');
        }).catch((error) => {
            console.log(error);
            this.UI.addToast('Erro na alteração do local');
        });
    };
    editDetalhes = () => {
        let amostra = angular.copy(this.amostra);
        let marcas = angular.copy(this.marcas);
        let options = {
            size: 'lg',
            template: require('./sample.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.amostra = amostra;
                    scope.marcas = marcas;
                    scope.ok = () => {
                        dialog.close(scope.amostra);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let dialog = this.UI.showDialog(options);
        dialog.then((res) => {
            if (angular.isDefined(res)) {
                this.loaded = false;
                this.amostra = res;
                if (this.amostra.marca) {
                    this.LmeMarca.upsert(amostra.marca).$promise.then((marca) => {
                        this.amostra.marca.id = marca.id;
                        this.amostra.marcaId = marca.id;
                        this.amostra.$save().then(() => {
                            this.UI.addToast('Amostra atualizada com sucesso');
                            this.loadData();
                        }).catch((err) => {
                            console.log(err);
                            this.UI.addToast('Erro a atualizar detalhes da amostra');
                            this.loadData();
                        });
                    }).catch((err) => {
                        console.log(err);
                        if (this.amostra.marca.id === 0) {
                            this.UI.addToast('Erro ao adicionar marca');
                        }
                        this.loadData();
                    });
                }
                else { // No marca is defined, set it to null
                    this.amostra.marca = null;
                    this.amostra.marcaId = null;
                    this.amostra.$save().then(() => {
                        this.UI.addToast('Amostra atualizada com sucesso');
                        this.loadData();
                    }).catch((err) => {
                        console.log(err);
                        this.UI.addToast('Erro a atualizar detalhes da amostra');
                        this.loadData();
                    });
                }
            }
        }).catch(() => {
        });
    };
    limitTo = (s) => {
        if (angular.isDefined(this.history[s])) {
            this.history[s] = undefined;
        }
        else {
            this.history[s] = 3;
        }
    };
    editEstado = () => {
        let estados = angular.copy(this.estados);
        let amostra = angular.copy(this.amostra);
        let locaisInside = angular.copy(this.locaisInside);
        let locaisOutside = angular.copy(this.locaisOutside);
        // Trim the current state of amostra
        estados = estados.filter(e => e.id !== amostra.estadoId);
        let options = {
            size: 'lg',
            template: require('./../directory/state.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.estados = estados;
                    scope.amostra = amostra;
                    scope.locaisInside = locaisInside;
                    scope.locaisOutside = locaisOutside;
                    scope.state = {
                        novoEstado: { selected: null },
                        novoLocal: { selected: null }
                    };
                    scope.isInside = (estado) => {
                        // Returns true if amostra is located inside, false otherwise
                        return estado && estado.inside;
                    };
                    scope.ok = () => {
                        dialog.close(scope.state);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(res => {
            this.loaded = false;
            if (angular.isDefined(res)) {
                this.LmeAmostraAlteracaoEstado.create({
                    id: 0,
                    inicialId: this.amostra.estadoId,
                    finalId: res.novoEstado.selected.id,
                    dataAlteracao: new Date(),
                    amostraId: this.id,
                    funcionarioId: this.Auth.getId(),
                    observacoes: res.observacoes,
                    active: true
                }).$promise.then(() => {
                    // Update estado da amostra - update the related object and not the field estadoId itself (using $save())
                    this.amostra.estado.id = res.novoEstado.selected.id;
                    // Se devolvido ao cliente ou no exterior, mete local para fora das instalações
                    if (!res.novoEstado.selected.inside) {
                        let oldLocal = this.amostra.localId;
                        this.amostra.local.id = 4; // Fora das instalações
                        this.LmeAmostraAlteracaoLocal.create({
                            id: 0,
                            amostraId: this.amostra.id,
                            inicialId: oldLocal,
                            finalId: this.amostra.local.id, // 4
                            observacoes: res.observacoes,
                            dataAlteracao: new Date(),
                            funcionarioId: this.Auth.getId(),
                            active: true
                        }).$promise.then(() => {
                            // Save amostra after changing its location
                            this.amostra.$save().then(() => {
                                this.loadData();
                                this.UI.addToast('Alteração de estado efetuada');
                            }).catch((err) => {
                                console.log(err);
                                this.UI.addToast('Erro ao alterar estado');
                            });
                        }).catch((error) => {
                            console.log(error);
                            this.UI.addToast('Erro na alteração do local');
                        });
                    }
                    else { // We are moving to an "inside" state
                        // Check if amostra is located outside, if so, move it back in
                        if (!this.amostra.local.inside) { // Fora das instalações
                            let oldLocal = this.amostra.local.id;
                            this.amostra.local.id = res.novoLocal.selected.id;
                            this.LmeAmostraAlteracaoLocal.create({
                                id: 0,
                                amostraId: this.amostra.id,
                                inicialId: oldLocal, // 4
                                finalId: this.amostra.local.id,
                                observacoes: res.observacoes,
                                dataAlteracao: new Date(),
                                funcionarioId: this.Auth.getId(),
                                active: true
                            }).$promise.then(() => {
                                this.amostra.$save().then((am) => {
                                    this.loadData();
                                    this.UI.addToast('Alteração de estado efetuada');
                                }).catch((err) => {
                                    console.log(err);
                                    this.UI.addToast('Erro ao alterar estado');
                                });
                            }).catch((error) => {
                                console.log(error);
                                this.UI.addToast('Erro na alteração do local');
                            });
                        }
                        else { // Otherwise, just save amostra
                            this.amostra.$save().then((am) => {
                                this.loadData();
                                this.UI.addToast('Alteração de estado efetuada');
                            }).catch((err) => {
                                console.log(err);
                                this.UI.addToast('Erro ao alterar estado');
                            });
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast('Erro ao alterar estado');
                });
            }
        });
    };
    validEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    resyncClient = (id) => {
        this.LmeCliente.findOne({
            filter: {
                where: {
                    id: id
                }
            }
        }).$promise.then((c) => {
            if (!c.refClientePrimavera) {
                this.UI.addToast("Não foi possível atualizar cliente.");
            }
            else {
                let PRIClientes = this.LmeService.getPRIClientes(c);
                PRIClientes.find({
                    filter: {
                        where: {
                            cliente: c.refClientePrimavera
                        }
                    }
                }).$promise.then((res) => {
                    if (res && res.length > 0) {
                        c.nome = res[0].nome;
                        c.nif = res[0].numcontrib;
                        c.cp4 = res[0].facCp.split("-")[0];
                        c.cp3 = res[0].facCp.split("-")[1];
                        c.localidade = res[0].facCploc;
                        c.contactoTelefonico = res[0].facTel;
                        c.morada = res[0].facMor;
                        c.observacoes = res[0].notas;
                        c.atualizadoa = res[0].dataultimaactualizacao;
                        c.refClientePrimavera = res[0].cliente;
                        c.email = this.validEmail(res[0].cduEmail) ? res[0].cduEmail : null;
                        c.$save().then((updatedCliente) => {
                            this.loadData();
                            this.UI.addToast('Sincronização realizada com sucesso.');
                        }).catch(err => {
                            console.log(err);
                            this.UI.addToast("Falha na gravação do fabricante. Por favor tente mais tarde.");
                        });
                    }
                    else {
                        this.UI.addToast("Não foi possível atualizar cliente.");
                    }
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Não foi possível atualizar cliente.");
                });
            }
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível atualizar cliente.");
        });
    };
    addAnexo = () => {
        let options = {
            size: 'lg',
            controller: 'LMEAmostraFileUploaderController',
            controllerAs: 'm',
            template: require('./files.dialog.html'),
            resolve: {
                pID: () => {
                    return this.amostra.id;
                },
                file: () => {
                    return undefined;
                }
            }
        };
        let dialog = this.UI.showDialog(options);
        dialog.then(res => {
            if (res) {
                this.loadData();
                this.UI.addToast('Ficheiro carregado com sucesso');
            }
        });
    };
    editAnexo = (f) => {
        let options = {
            size: 'lg',
            controller: 'LMEAmostraFileUploaderController',
            controllerAs: 'm',
            template: require('./files.dialog.html'),
            resolve: {
                pID: () => {
                    return this.amostra.id;
                },
                file: () => {
                    return f.info;
                }
            }
        };
        let dialog = this.UI.showDialog(options);
        dialog.then(res => {
            if (res) {
                this.loadData();
                this.UI.addToast('Ficheiro carregado com sucesso');
            }
        });
    };
    removeAnexo = (file) => {
        let confirm = this.UI.showConfirm('Deseja remover o ficheiro?');
        confirm.then(res => {
            if (res) {
                file.info.active = 0;
                this.LmeAmostraDocumentos.upsert(file.info).$promise.then(() => {
                    this.loadData();
                    this.UI.addToast('Ficheiro removido');
                });
            }
        });
    };
    generateUUID = () => {
        let uuid = "", i, random;
        for (i = 0; i < 32; i++) {
            random = Math.random() * 16 | 0;
            if (i == 8 || i == 12 || i == 16 || i == 20) {
                uuid += "-";
            }
            uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
        }
        return uuid;
    };
    addImage = () => {
        let options = {
            size: 'lg',
            template: require('./images.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
                    $scope.images = {};
                    $scope.label = "Adicionar imagem";
                    $scope.newFileName = '';
                    $scope.oldFileName = '';
                    $scope.observacoes = null;
                    $scope.uuid = this.generateUUID();
                    $scope.uploader = new this.FileUploader({
                        url: '/api/Upload/lme/upload',
                        queueLimit: 1,
                        formData: [
                            {
                                key: 'value'
                            }
                        ]
                    });
                    let filter = {
                        name: 'verifyIMG',
                        fn: function (item, options) {
                            return item.type.indexOf("image/") !== -1;
                        }
                    };
                    $scope.uploader.filters.push(filter);
                    $scope.uploader.onAfterAddingFile = (item) => {
                        let partes = item.file.name.split(".");
                        $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];
                        if ($scope.uploader.queue.length > 1)
                            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
                        $scope.oldFileName = $scope.uploader.queue[0].file.name;
                    };
                    $scope.uploader.onWhenAddingFileFailed = (img) => {
                        this.UI.addToast("Por favor, carregue uma imagem");
                    };
                    $scope.uploader.onErrorItem = (response, status, headers) => {
                        this.UI.addToast("A imagem não foi carregada com sucesso");
                    };
                    $scope.uploader.onBeforeUploadItem = (item) => {
                        item.file.name = $scope.newFileName;
                    };
                    $scope.ok = () => {
                        $dialog.close($scope);
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialogCreate = this.UI.showDialog(options);
        dialogCreate.then((ok) => {
            this.LmeAmostraDocumentos.create({
                id: 0,
                amostraId: this.amostra.id,
                documentoId: 3,
                nome: ok.newFileName,
                date: new Date(),
                observacoes: ok.observacoes || null,
                active: 1
            }).$promise.then((res) => {
                if (ok.newFileName) {
                    // File exists, upload it
                    ok.uploader.uploadAll();
                    this.loadData();
                }
                else {
                    // No file, just update the list
                    this.loadData();
                }
                this.UI.addToast("Imagem adicionada com sucesso!");
            }).catch(err => {
                this.UI.addToast("Erro a adicionar imagem.");
                console.log(err);
            });
        }).catch((error) => {
            if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
                console.log(error);
        });
    };
    // Format bytes into correct units
    formatBytes = (bytes, decimals) => {
        if (bytes == null)
            return "N/D";
        if (bytes === 0)
            return '0 Bytes';
        let k = 1024, dm = decimals <= 0 ? 0 : decimals || 2, sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };
    generateEtiqueta = () => {
        // Check if valid
        if (this.amostra.movimentacoes && this.amostra.movimentacoes.length > 0) {
            window.open(`/api/lmeamostras/etiqueta?id=${this.amostra.id}&access_token=${this.Auth.getToken()}`, "_blank").focus();
        }
        else {
            this.UI.addToast("Amostra informação relevante para geração de etiqueta registada");
        }
    };
}
LmeDetailsWarehouseController.$inject = ['$state', '$filter', 'UIService', 'AuthenticationService', 'LmeService', 'LmeAmostra', 'LmeCliente', 'PRIClientes', 'PRIAJLClientes', 'LmeMarca', 'LmeEstadoAmostra', 'LmeAmostraAlteracaoEstado', 'LmeAmostraAlteracaoLocal', 'LmeLocal', 'LmeAmostraDocumentos', '$http', 'FileUploader'];
